import { Stage, Client } from '../types/Utils';

export const isDev = process.env.NODE_ENV === 'development';

export const getSiteUrl = (clientCode: Client, env: Stage) => {
    if (env === Stage.Live || env === Stage.Dev) {
        if (clientCode === Client.AOL) return 'https://ao.com';
        if (clientCode === Client.ADE) return 'https://www.ao.de';
        if (clientCode === Client.TUK) return 'https://www.ao-business.com';
    }

    return `https://${env.toLowerCase()}-${clientCode.toLowerCase()}.ao-qa.com`;
};


export const getClientByDomain = (domain: string, defaultClient: string) => {
    const hostname = !domain ? window.location.hostname : domain;
    let client = defaultClient;
    if (hostname.includes('ao.com') || hostname.includes('-aol')) client = 'AOL';
    if (hostname.includes('ao.de') || hostname.includes('-ade')) client = 'ADE';
    if (hostname.includes('ao-business.com') || hostname.includes('-tuk')) client = 'TUK';

    if (hostname.includes('beta-reviews'))
	{
		if (window.location.search.includes('clientId=1')) client = 'AOL';
		if (window.location.search.includes('clientId=44')) client = 'ADE';
		if (window.location.search.includes('clientId=53')) client = 'TUK';
    }
    
    return client;
};
